import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { getToken } from 'src/hooks';
import { queryKeys } from 'src/utils';

const topics = [
  'assemblies',
  'components',
  'dayparts',
  'layouts',
  'locations',
  'products',
];

export function useSbNoseWebSocket() {
  const queryClient = useQueryClient();
  const socketRef = useRef<WebSocket>();

  useEffect(() => {
    const token = getToken();
    const url = window?.environment?.urls?.sbNose;
    if (token && url) {
      const socket = new WebSocket(`${url}?accessToken=${token}&app=cc`);

      socketRef.current = socket;

      socket.onopen = () => {
        if (
          socketRef.current &&
          socketRef.current.readyState === WebSocket.OPEN
        ) {
          // auto-subscribe initial topics
          socketRef.current.send(
            JSON.stringify({
              action: 'subscribe',
              topics,
            }),
          );
        } else {
          console.error(
            'Could not subscribe to topics, WebSocket connection error!',
          );
        }
      };

      socket.onmessage = (_event) => {
        // Basically this is all react-query needs to get the fresh user actions data
        queryClient.invalidateQueries(queryKeys.userActions.invalidateAll());
      };

      socket.onerror = (ev: Event) => {
        console.error('Error while connecting to websocket', ev);
        socket.close();
      };

      return () => {
        socket.close();
      };
    } else {
      console.error(
        'Cannot open the WebSocket connection, either token or url are wrong!',
      );
    }
  }, [queryClient]);
}
